import { Link } from '@tanstack/react-router';
import { CalendarRange, ChevronLeft, Plus } from 'lucide-react';
import { Button } from '../../components/ui/button';

interface StoryToolbarProps {
  readonly caseId: string;
  readonly canWrite: boolean;
  readonly onNewPeriod: () => void;
  readonly onOpenPeriods: () => void;
}

export function StoryToolbar({ caseId, canWrite, onNewPeriod, onOpenPeriods }: StoryToolbarProps) {
  return (
    <>
      <div className="pointer-events-none absolute left-3 top-3 z-30">
        <Link
          to="/cases/$caseId"
          params={{ caseId }}
          className="pointer-events-auto inline-flex items-center gap-1 rounded-md border border-white/12 bg-surface/75 px-2.5 py-1.5 text-xs text-text-secondary shadow-lg backdrop-blur-md transition-colors hover:bg-white/8 hover:text-text-primary"
        >
          <ChevronLeft size={13} />
          Tilbake til sak
        </Link>
      </div>
      <div className="pointer-events-none absolute right-3 top-3 z-30 flex gap-2">
        <div className="pointer-events-auto flex items-center gap-1 rounded-lg border border-white/10 bg-surface/75 p-1 shadow-lg backdrop-blur-md">
          <Button
            type="button"
            variant="ghost"
            className="gap-1.5 px-2.5 py-1.5 text-xs"
            onClick={onOpenPeriods}
          >
            <CalendarRange size={14} />
            Tidsslotter
          </Button>
          {canWrite && (
            <Button
              type="button"
              variant="outline"
              className="gap-1.5 px-2.5 py-1.5 text-xs"
              onClick={onNewPeriod}
            >
              <Plus size={14} />
              Ny tidsslott
            </Button>
          )}
        </div>
      </div>
    </>
  );
}
